import React from "react";
import Page, { PageProps } from "../Page";
import { IPaymentInstructionPresenter } from "../../../presenter/payment/PaymentInstructionPresenter";
import PaymentInstructionDetails from "../../components/payment-instruction/PaymentInstructionDetails";
import Header from "../../components/Header";
import Loader from "../../components/Loader";

export interface Props extends PageProps {}
export interface State extends IPaymentInstructionPresenter {}

export default class PaymentInstructionPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      paymentInstruction,
      loaders,
      changeLanguage,
      languageCode
    } = this.state;

    return (
      <Page {...this.props}>
        <Header
          title={translate("pages.payment_instruction")}
          languagePickerVisible={true}
          onLanguageChange={(languageCode) => changeLanguage(languageCode)}
          language={languageCode}
        />
        <div className="content-wrapper">
          <Loader
            loading={loaders.paymentInstructionLoader}
            children={
              <PaymentInstructionDetails
                translate={translate}
                paymentInstruction={paymentInstruction}
              />
            }
          />
        </div>
      </Page>
    );
  }
}
